import { useEffect, useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';

// redux
import { mapDispatchProps, mapStateToProps } from '../../../store/store';
import { connect } from 'react-redux';
import Button from '../../../components/button';
import { ROUTES } from '../../../routes';
import { useNavigate } from 'react-router';
import API from '../../../api';

import './styles.css';
import { TECollapse } from 'tw-elements-react';
import Fetcher from '../../../libraries/fetcher';
import OnAfterModalClosed from '../../../libraries/onAfterModalClosed';
import LoadingText from '../../../components/loadingText';
import { useLanguage } from '@languages/index';

const kAdderForMore = 6;

const SNSBrandReview = (props: any) => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.sns };
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const onAfterModalClosed = new OnAfterModalClosed(props);

  // query
  const fetchBrandRes = useQuery({
    queryKey: ['fetch_brand'],
    queryFn: async () => {
      try {
        const res = await API.Brand.show({ brandToken: props.auth.token });
        props.setBrand(res.data.brand);

        return res;
      } catch (error) {
        props.showModal({
          hideCloseButton: true,
          text: languageTexts.index_text_1,
        });
      }
    },
  });
  if (
    fetchBrandRes.data &&
    fetchBrandRes.data.brand &&
    fetchBrandRes.data.brand.hasExperiencedSnsInstall &&
    !fetchBrandRes.data.brand.snsPassInstalledAt
  ) {
    //navigate(ROUTES.SNS_PAYMENT_COMPLETE.PATH);
    return null;
  }

  // common
  const buildLoadingCase = () => {
    return (
      <div className="flex flex-row justify-center">
        <span className="mt-[79px] mb-[96px] bold text-[22px] text-[#C8C8C8]">
          {languageTexts.index_text_2}
        </span>
      </div>
    );
  };
  const buildEmptyCase = (name: string) => {
    return (
      <div className="flex flex-row justify-center">
        <span className="mt-[79px] mb-[96px] bold text-[22px] text-[#C8C8C8]">
          {languageTexts._index_text_3(name)}
        </span>
      </div>
    );
  };
  const makeQueriesAndEffectsAndFuncsForReview = (
    reviewName,
    reviewQueryName, // ex) celebs for count_celebs, get_celebs_fetcher, ...
    isReviewFolded,
    setReviewFolded,
    fetchedReviewCount,
    reviews,
    setReviews,
    countApiFunc,
    fetchApiFunc,
    updateApiFunc,
  ): any => {
    const countRes = useQuery({
      queryKey: [`count_${reviewQueryName}`, fetchBrandRes.data?.brand?.id],
      queryFn: async () => {
        try {
          const res = await countApiFunc({
            brandToken: props.auth.token,
            masterToken: props.auth.masterToken,
          });
          return res.data.count;
        } catch (error) {
          props.showModal({
            hideCloseButton: true,
            text: languageTexts._index_text_4(reviewName),
          });
        }
      },
      enabled: !!fetchBrandRes.data,
    });
    const reviewFetcherRes = useQuery({
      queryKey: [
        `get_${reviewQueryName}_fetcher`,
        fetchBrandRes.data?.brand?.id,
      ],
      queryFn: () =>
        new Fetcher(async (offset: number, limit: number) => {
          const res = await fetchApiFunc({
            brandToken: props.auth.token,
            masterToken: props.auth.masterToken,
            offset,
            limit,
          });
          return res.data.reviews;
        }),
      enabled: !!fetchBrandRes.data,
    });
    const fetchReviewsRes = useQuery({
      queryKey: [
        `fetch_${reviewQueryName}`,
        fetchBrandRes.data?.brand?.id,
        fetchedReviewCount,
      ],
      queryFn: async () => {
        try {
          const reviews = await reviewFetcherRes.data.fetch(fetchedReviewCount);
          return reviews;
        } catch (error) {
          props.showModal({
            hideCloseButton: true,
            text: languageTexts._index_text_4(reviewName),
          });
        }
      },
      enabled: !!reviewFetcherRes.data,
    });
    const removeReviewQueries = () => {
      queryClient.removeQueries({ queryKey: [`count_${reviewQueryName}`] });
      queryClient.removeQueries({
        queryKey: [`get_${reviewQueryName}_fetcher`],
      });
      queryClient.removeQueries({ queryKey: [`fetch_${reviewQueryName}`] });
    };
    useEffect(() => {
      // on fetchReviewsRes.data updated
      if (!fetchReviewsRes.data) return;

      // set reviews
      const newReviews = fetchReviewsRes.data;
      setReviews(newReviews);

      setTimeout(() => {
        if (isReviewFolded === false) {
          setReviewFolded(true);
          setReviewFolded(false);
        }
      }, 1);
    }, [fetchReviewsRes.data]);
    const setReviewPublishState = async (idx: any, value: boolean) => {
      if (!reviews || idx < 0 || idx >= reviews.length) return;

      const rv = reviews[idx];
      if (!!rv.isPublished === value) return;

      try {
        props.showModal({
          hideCloseButton: true,
          hideConfirmButton: true,
          content: () => {
            return (
              <div className="font-bold text-3xl text-white select-none">
                <LoadingText
                  text={languageTexts.index_text_5}
                  render={(text) => {
                    return <span>{text}</span>;
                  }}
                />
              </div>
            );
          },
        });

        const res = await updateApiFunc(rv.id, {
          brandToken: props.auth.token,
          masterToken: props.auth.masterToken,
          isPublished: value,
        });
        if (reviewFetcherRes.data.getResources()[idx]) {
          await reviewFetcherRes.data.refetch(idx, 1);
          reviews[idx] = reviewFetcherRes.data.getResources()[idx];
          setReviews(reviews.slice());
        } else {
          queryClient.removeQueries({ queryKey: [`fetch_${reviewQueryName}`] });
        }

        props.closeModal();
      } catch (error) {
        onAfterModalClosed.set(() => {
          props.showModal({
            hideCloseButton: true,
            text: languageTexts._index_text_6(reviewName),
          });
        });
        props.closeModal();
      }
    };

    return [
      countRes,
      reviewFetcherRes,
      fetchReviewsRes,
      removeReviewQueries,
      setReviewPublishState,
    ];
  };

  /*
  // about celeb
  const [isCelebFolded           , setCelebFolded             ] = useState(true);
  const [fetchedCelebCount       , setFetchedCelebCount       ] = useState(3);
  const [celebReviews            , setCelebReviews            ] = useState(null);
  const [
      countCelebsRes,
      celebsFetcherRes,
      fetchCelebsRes,
      removeCelebQueries,
      setCelebPublishState,
  ] =
      makeQueriesAndEffectsAndFuncsForReview(
          '연예인 리뷰',
          'celebs',
          isCelebFolded,
          setCelebFolded,
          fetchedCelebCount,
          celebReviews,
          setCelebReviews,
          API.BrandSns.countCelebrities,
          API.BrandSns.fetchCelebrities,
          API.BrandSns.updateCelebrity,
      );
  */

  // about youtube
  const [isYoutubeFolded, setYoutubeFolded] = useState(true);
  const [fetchedYoutubeCount, setFetchedYoutubeCount] = useState(3);
  const [youtubeReviews, setYoutubeReviews] = useState(null);
  const [
    countYoutubesRes,
    youtubesFetcherRes,
    fetchYoutubesRes,
    removeYoutubeQueries,
    setYoutubePublishState,
  ] = makeQueriesAndEffectsAndFuncsForReview(
    languageTexts.index_text_7,
    'youtubes',
    isYoutubeFolded,
    setYoutubeFolded,
    fetchedYoutubeCount,
    youtubeReviews,
    setYoutubeReviews,
    API.BrandSns.countYoutubes,
    API.BrandSns.fetchYoutubes,
    API.BrandSns.updateYoutube,
  );

  /*
  // about video
  const [isVideoFolded    , setVideoFolded      ] = useState(true);
  const [fetchedVideoCount, setFetchedVideoCount] = useState(3);
  const [videoReviews     , setVideoReviews     ] = useState(null);
  const [
      countVideosRes,
      videosFetcherRes,
      fetchVideosRes,
      removeVideoQueries,
      setVideoPublishState,
  ] =
      makeQueriesAndEffectsAndFuncsForReview(
          '비디오 리뷰',
          'videos',
          isVideoFolded,
          setVideoFolded,
          fetchedVideoCount,
          videoReviews,
          setVideoReviews,
          API.BrandSns.countVideos,
          API.BrandSns.fetchVideos,
          API.BrandSns.updateVideo,
      );
  */

  // build main
  const build = () => {
    if (!fetchBrandRes.data) return null;

    if (!props.brand?.hasExperiencedSnsInstall || !props.brand?.remainSnsPass)
      return null;

    return (
      <div className="flex flex-col w-full">
        <div className="flex flex-row justify-left mb-[5px]">
          <span className="font-bold text-[22px]">
            {languageTexts.index_text_8}
          </span>
        </div>

        <div style={{ height: '75px' }} />

        {/*celeb menu*/}
        {/*_buildContents(
              'CELEBRITY',
              countCelebsRes.data,
              () => {
                removeCelebQueries();
                navigate(ROUTES.SNS_ORDER_CELEB.PATH);
              },
              () => {
                removeCelebQueries();
                navigate(ROUTES.SNS_UPLOAD_CELEB.PATH);
              },
              isCelebFolded,
              setCelebFolded,
              () => _buildElems(
                  '연예인 리뷰',
                  celebReviews,
                  (review, ri) => (
                      <div
                          key={review.id + '.img_and_title'}
                          className={'cursor-pointer flex flex-col w-[331px] ' + ((ri!==0)? 'ml-[16px]':'')}
                          onClick={(e)=>{navigate(ROUTES.SNS_CELEB_DETAIL.PATH.split(':')[0] + review.id)}}
                      >
                        <img
                            className={'object-contain w-[331px] h-[331px]'}
                            src={Util.makeImageUrl("brand_sns/thumb-sm", review.thumbnailUrl)}
                        />
                        <span className="mt-[10px] text-[15px]">{review.title}</span>
                      </div>
                  ),
                  setCelebPublishState,
                  countCelebsRes.data,
                  fetchedCelebCount,
                  setFetchedCelebCount,
              ),
          )*/}

        {/*youtube menu*/}
        <div className="mt-[36px]" />
        {_buildContents(
          'YOUTUBE',
          countYoutubesRes.data,
          () => {
            removeYoutubeQueries();
            navigate(ROUTES.SNS_ORDER_YOUTUBE.PATH);
          },
          () => {
            removeYoutubeQueries();
            navigate(ROUTES.SNS_UPLOAD_YOUTUBE.PATH);
          },
          isYoutubeFolded,
          setYoutubeFolded,
          () =>
            _buildElems(
              languageTexts.index_text_7,
              youtubeReviews,
              (review, ri) => (
                <div
                  key={review.id}
                  className={
                    'cursor-pointer flex flex-col w-[331px] ' +
                    (ri !== 0 ? 'ml-[16px]' : '')
                  }
                  onClick={(e) => {
                    navigate(
                      ROUTES.SNS_YOUTUBE_DETAIL.PATH.split(':')[0] + review.id,
                    );
                  }}
                >
                  <div style={{ position: 'relative' }}>
                    <img
                      className={'object-cover w-[331px] h-[186px]'}
                      src={`http://img.youtube.com/vi/${review.videoKey}/mqdefault.jpg`}
                    />
                    <span
                      className="pl-[7px] pr-[3px] py-[4px] font-bold text-[13px] text-[#ffffff] bg-[#0000003C]"
                      style={{
                        position: 'absolute',
                        bottom: '0px',
                        right: '0px',
                      }}
                    >
                      {review.duration}
                    </span>
                  </div>
                  <span className="mt-[10px] text-[15px]">{review.title}</span>
                  <div style={{ height: '10px' }} />
                  <div className="flex flex-row items-center">
                    <div
                      style={{
                        width: '32px',
                        height: '32px',
                        position: 'relative',
                        overflow: 'hidden',
                        borderRadius: '50%',
                      }}
                    >
                      <img
                        src={review.channelThumbnailUrl}
                        style={{
                          display: 'inline',
                          margin: '0 auto',
                          height: '100%',
                          width: 'auto',
                        }}
                      />
                    </div>
                    <span className="ml-[12px] text-[15px]">
                      {review.channelTitle}
                    </span>
                  </div>
                </div>
              ),
              setYoutubePublishState,
              countYoutubesRes.data,
              fetchedYoutubeCount,
              setFetchedYoutubeCount,
            ),
        )}

        {/* <div className="mt-[36px]" /> */}
        {/*video menu*/}
        {/* {_buildContents(
              'VIDEO',
              countVideosRes.data,
              () => {
                removeVideoQueries();
                navigate(ROUTES.SNS_ORDER_VIDEO.PATH);
              },
              () => {
                removeVideoQueries();
                navigate(ROUTES.SNS_UPLOAD_VIDEO.PATH);
              },
              isVideoFolded,
              setVideoFolded,
              () => _buildElems(
                  '비디오 리뷰',
                  videoReviews,
                  (review, ri) => (
                      <div
                          key={review.id}
                          className={'cursor-pointer flex flex-col w-[331px] ' + ((ri!==0)? 'ml-[16px]':'')}
                          onClick={(e)=>{navigate(ROUTES.SNS_VIDEO_DETAIL.PATH.split(':')[0] + review.id)}}
                      >
                        <div style={{position:'relative'}}>
                          <img
                              className={'object-cover w-[331px] h-[186px]'}
                              src={`http://img.youtube.com/vi/${review.videoKey}/mqdefault.jpg`}
                          />
                          <span
                            className="pl-[7px] pr-[3px] py-[4px] font-bold text-[13px] text-[#ffffff] bg-[#0000003C]"
                            style={{position:'absolute', bottom:'0px', right:'0px'}}
                          >
                            {review.duration}
                          </span>
                        </div>
                        <span className="mt-[10px] text-[15px]">{review.title}</span>
                      </div>
                  ),
                  setVideoPublishState,
                  countVideosRes.data,
                  fetchedVideoCount,
                  setFetchedVideoCount,
                  props.auth.isMaster,
              ),
              props.auth.isMaster,
              props.auth.isMaster,
          )} */}
      </div>
    );
  };

  const _buildContents = (
    title,
    count,
    onClickOrderFunc,
    onClickUploadFunc,
    isFolded,
    setFolded,
    buildElemsFunc,
    needOrderButton = true,
    needUploadButton = true,
  ) => {
    return (
      <div>
        {/* menu */}
        <div className="flex flex-row items-center">
          <span className="flex-none font-bold text-[17px]">
            {title} ({count || 0})
          </span>
          <span className="grow"></span>
          {!needOrderButton ? null : (
            <span
              className="flex-none text=[15px] underline mr-[22px] cursor-pointer"
              onClick={() => onClickOrderFunc()}
            >
              {languageTexts.index_text_9}
            </span>
          )}
          {!needUploadButton ? null : (
            <span
              className="flex-none text=[15px] underline mr-[30px] cursor-pointer"
              onClick={() => onClickUploadFunc()}
            >
              {languageTexts.index_text_10}
            </span>
          )}
          {isFolded ? (
            <img
              className="flex-none"
              src="/assets/icons/unfold.svg"
              onClick={(e) => setFolded(false)}
            />
          ) : (
            <img
              className="flex-none"
              src="/assets/icons/fold.svg"
              onClick={(e) => setFolded(true)}
            />
          )}
        </div>

        {/* elements */}
        <TECollapse className="shadow-none" show={!isFolded}>
          <div className="">{isFolded ? null : buildElemsFunc()}</div>
        </TECollapse>
      </div>
    );
  };

  const _buildElems = (
    reviewName,
    reviews,
    onBuildReviewFunc,
    setReviewPublishStateFunc,
    reviewCount,
    fetchedReviewCount,
    setFetchedReviewCount,
    isPublishUpdaterButtonsAvailable = true,
    groupByCount = 3,
  ) => {
    if (!reviews) return buildLoadingCase();

    // empty case
    if (reviews.length <= 0) return buildEmptyCase(reviewName);

    // group elements by groupByCount
    const groupedElems = [];
    for (let ri = 0; ri < reviews.length; ++ri) {
      if (ri % groupByCount === 0) groupedElems.push([]);

      const rv = reviews[ri];
      rv.idx = ri;
      groupedElems[groupedElems.length - 1].push(rv);
    }

    // build
    return (
      <div className="flex flex-col">
        {groupedElems.map(
          // per group
          (elemList, gi) => (
            <div key={gi} className="mb-[30px]">
              {/* image and title */}
              <div className="flex flex-row">
                {elemList.map((review, ri) => onBuildReviewFunc(review, ri))}
              </div>

              {/* publish buttons */}
              <div className="flex flex-row">
                {elemList.map((review, ri) => (
                  <div
                    key={review.id + '.publish_buttons'}
                    className={
                      'flex flex-col w-[331px] ' + (ri !== 0 ? 'ml-[16px]' : '')
                    }
                  >
                    <div className="mt-[10px] flex flex-row">
                      <Button
                        borderColor={review.isPublished ? '#000000' : '#E8E8E8'}
                        buttonColor={review.isPublished ? '#000000' : 'WHITE'}
                        textColor={review.isPublished ? 'WHITE' : 'BLACK'}
                        text={languageTexts.public}
                        textClassName={'text-[14px]'}
                        onClick={() => {
                          if (isPublishUpdaterButtonsAvailable)
                            setReviewPublishStateFunc(review.idx, true);
                        }}
                      />
                      <Button
                        buttonColor={review.isPublished ? 'WHITE' : '#E8E8E8'}
                        borderColor={review.isPublished ? '#E8E8E8' : '#E8E8E8'}
                        text={languageTexts.private}
                        textClassName={'text-[14px]'}
                        onClick={() => {
                          if (isPublishUpdaterButtonsAvailable)
                            setReviewPublishStateFunc(review.idx, false);
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ),
        )}
        {!reviewCount || fetchedReviewCount >= reviewCount ? null : (
          <Button
            buttonColor="WHITE"
            borderColor="#E8E8E8"
            text={languageTexts._index_text_11(reviewName)}
            textClassName={'text-[14px]'}
            onClick={() =>
              setFetchedReviewCount(fetchedReviewCount + kAdderForMore)
            }
          />
        )}
      </div>
    );
  };

  return build();
};

export default connect(mapStateToProps, mapDispatchProps)(SNSBrandReview);
